'use strict';

var vehicleImg = function () {

  var _getImgUrls = function _getImgUrls(vehicle, view, size) {
    var urls = {};
    var color2 = vehicle.vhexadecimalBitono.trim() !== '' ? vehicle.vhexadecimalBitono.split('#')[1] : '';
    var carbody = vehicle.nseccionCB !== 1 && vehicle.vimgCarro.trim() !== '' ? '-' + vehicle.vimgCarro : '';
    var carconfig = (vehicle.nseccionCB === 2 || vehicle.vimgModelo === 'np300navara') && vehicle.vimgConfig.trim() !== '' ? '-' + vehicle.vimgConfig : '';
    var layers = ['shadows', 'lights', 'base'];

    if (vehicle.vhexadecimalBitono.trim() !== '') {
      layers.push('color2');
    }
    var layer, versionOrMultiple, color2Str;
    for (var i = 0; i < layers.length; i++) {
      var layerType = layers[i];
      switch (layerType) {
        case 'shadows':
          layer = 'n';
          versionOrMultiple = vehicle.bimgMultiple ? 'multiple' : vehicle.vimgGrado;
          color2Str = '-';
          break;

        case 'lights':
          layer = 'b';
          versionOrMultiple = vehicle.bimgMultiple ? 'multiple' : vehicle.vimgGrado;
          color2Str = '-';
          break;

        case 'base':
          layer = 'g';
          versionOrMultiple = vehicle.vimgGrado;
          color2Str = '' + '-';
          break;

        case 'color2':
          layer = 't';
          versionOrMultiple = vehicle.vimgGrado;
          color2Str = '-' + color2 + '-';
      }

      urls[layerType] = 'images/coches/' + vehicle.vimgModelo + '-' + view + carbody + carconfig + '-' + layer + '-' + versionOrMultiple + color2Str + size + '.png';
    }
    /* console.log(vehicle)
    console.log('carbody', carbody, 'carconfig', carconfig, '\nurls\n', urls); */

    return urls;
  };
  var _getColorsAndImgs = function _getColorsAndImgs(colorElement, view, size) {
    var color1, color2;
    color1 = colorElement.vhexadecimal;
    if (colorElement.vhexadecimalBitono.trim() !== '') {
      color2 = colorElement.vhexadecimalBitono;
    }

    var resultObj = {
      colors: {
        first: color1
      },
      urls: _getImgUrls(colorElement, view, size),
      targets: {}
    };

    var layers = ['shadows', 'lights', 'base'];
    if (typeof color2 !== 'undefined') {
      resultObj.colors.second = color2;
      layers.push('color2');
    }

    var imgLayer;
    for (var i = 0; i < layers.length; i++) {
      var layerType = layers[i];
      switch (layerType) {
        case 'shadows':
          imgLayer = '.js-grises';
          break;

        case 'lights':
          imgLayer = '.js-brillos';
          break;

        case 'base':
          imgLayer = '.js-base';
          break;

        case 'color2':
          imgLayer = '.js-bitono';
      }

      resultObj.targets[layerType] = imgLayer;
    }
    return resultObj;
  };

  var _setColor2Img = function _setColor2Img(obj, target) {
    var newImg = $('<img/>');
    newImg.attr('src', obj.urls.color2).addClass('js-bitono js-layer');
    $(target).append(newImg);
  };

  return {
    getColorsAndImgs: _getColorsAndImgs,
    setColor2Img: _setColor2Img,
    getImgUrls: _getImgUrls
  };
}();